var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m44.2 10.599a23.897 23.897 0 0 1 4.8 14.4c0 13.256-10.745 24-24 24s-24-10.743-24-23.999c0-13.254 10.745-24 24-24 7.852 0 14.822 3.771 19.2 9.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44.2 10.599a23.897 23.897 0 0 1 4.8 14.4c0 13.256-10.745 24-24 24s-24-10.743-24-23.999c0-13.254 10.745-24 24-24 7.852 0 14.822 3.771 19.2 9.6",
  stroke: "#ff4438",
  strokeWidth: 1.44
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.538 11.935 5.37 20.043",
  stroke: "#003a70",
  strokeLinecap: "round",
  strokeWidth: 1.44
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.2 25a4.2 4.2 0 1 1 -8.4 0 4.2 4.2 0 0 1 8.4 0",
  fill: "#ff4438"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#003a70",
  strokeWidth: 1.44
}, /*#__PURE__*/React.createElement("path", {
  d: "m29.2 25a4.2 4.2 0 1 1 -8.4 0 4.2 4.2 0 0 1 8.4 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.8 24.856c0-10.604 8.596-19.2 19.2-19.2s19.2 8.596 19.2 19.2",
  strokeLinecap: "round"
})));
var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "0 0 50 50",
    width: 50,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Timer.4a716a58.svg";
export { ForwardRef as ReactComponent };